import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class Group extends ApplicationRecord {
  static jsonapiType = 'groups';

  @Attr() name: string;
  @Attr() id: string;
}
